import { render, staticRenderFns } from "./CompareTable.vue?vue&type=template&id=528a15d1&scoped=true&"
import script from "./CompareTable.vue?vue&type=script&lang=js&"
export * from "./CompareTable.vue?vue&type=script&lang=js&"
import style0 from "./CompareTable.vue?vue&type=style&index=0&id=528a15d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528a15d1",
  null
  
)

export default component.exports